// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 131 ? "document-viewer" : chunkId) + "-cf-" + {"131":"318ea4ca19896a2ae7b7","194":"5ed4878352ae12909844"}[chunkId] + ".js";
};